import { render, staticRenderFns } from "./PromotionEndDate.vue?vue&type=template&id=70d1dc4a&"
import script from "./PromotionEndDate.vue?vue&type=script&lang=ts&"
export * from "./PromotionEndDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports